import { parseISO as o, intlFormatDistance as c } from "date-fns";
function u(e) {
  return e > 9 ? "9+" : e;
}
function l(e, t = {}) {
  try {
    const r = o(e);
    return c(r, /* @__PURE__ */ new Date(), {
      locale: t.locale
    });
  } catch {
    return e;
  }
}
function d(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function f(e, t) {
  return e !== void 0 ? e : t;
}
function m(e, t, r = {}) {
  return [e, t, r.source, r.tenant, r.has_tenant, r.archived].filter((n) => n != null).join("-");
}
function s({
  knockSlackChannelId: e,
  tenant: t,
  connectionStatus: r,
  errorLabel: n
}) {
  return [e, t, r, n].filter((a) => a != null).join("-");
}
export {
  m as feedProviderKey,
  u as formatBadgeCount,
  l as formatTimestamp,
  f as renderNodeOrFallback,
  s as slackProviderKey,
  d as toSentenceCase
};
//# sourceMappingURL=utils.mjs.map
